import ImageTracker from './imageTracker';

// Store the instance and cleanup handlers to prevent duplicate initialization
let imageTrackerInstance: ImageTracker | null = null;
let unloadHandler: (() => void) | null = null;
let beforeUnloadHandler: (() => void) | null = null;

/**
 * Clean up the ImageTracker instance and remove all event listeners
 */
const cleanup = () => {
    if (imageTrackerInstance) {
        imageTrackerInstance.destroy();
        imageTrackerInstance = null;
    }

    // Remove all event listeners
    if (unloadHandler) {
        window.removeEventListener('unload', unloadHandler);
        unloadHandler = null;
    }

    if (beforeUnloadHandler) {
        window.removeEventListener('beforeunload', beforeUnloadHandler);
        beforeUnloadHandler = null;
    }
};

/**
 * Initialize Monitor instance
 * Prevents duplicate initialization and ensures proper cleanup
 */
export const initMonitor = (): ImageTracker | null => {
    // Return existing instance if already initialized
    if (imageTrackerInstance) {
        console.warn('ImageTracker already initialized, returning existing instance');
        return imageTrackerInstance;
    }

    try {
        imageTrackerInstance = new ImageTracker();

        // Setup cleanup handlers
        unloadHandler = () => {
            cleanup();
        };

        beforeUnloadHandler = () => {
            cleanup();
        };

        // Add multiple event listeners for better coverage
        // beforeunload is more reliable than unload in some browsers
        // pagehide is more reliable than unload on mobile devices
        window.addEventListener('beforeunload', beforeUnloadHandler);
        window.addEventListener('unload', unloadHandler);
        window.addEventListener('pagehide', unloadHandler);

        return imageTrackerInstance;
    } catch (error) {
        console.error('Failed to initialize ImageTracker:', error);
        cleanup();
        return null;
    }
};

/**
 * Manually destroy the monitor instance
 * Useful for testing or manual cleanup
 */
export const destroyMonitor = (): void => {
    cleanup();
};
